export default __webpack_public_path__ + "static/media/Journeyimportsample.e0196861.xlsx";